import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './styles/global-overflow-tooltip.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 统一从本地构建产物加载 Element UI，避免 CDN 冷启动慢
Vue.use(ElementUI);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');

